import { render, staticRenderFns } from "./Subnets.vue?vue&type=template&id=302f77ba&scoped=true&"
import script from "./Subnets.vue?vue&type=script&lang=ts&"
export * from "./Subnets.vue?vue&type=script&lang=ts&"
import style0 from "./Subnets.vue?vue&type=style&index=0&id=302f77ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302f77ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
